// extracted by mini-css-extract-plugin
export default {"root":"DatatypeCreateForm_root__37xQL","after":"DatatypeCreateForm_after__iAcH2","header":"DatatypeCreateForm_header__XXHLu"};